<template>
    <div id="tsparticles" style="position: fixed; inset: 0; z-index: 1;"></div>
</template>

<script>
export default {
    name: "Fireworks",
    mounted() {
        this.$nextTick(() => {
            if (window.tsParticles) {
                window.tsParticles.load("tsparticles", {
                    fullScreen: { zIndex: 1 },
                    emitters: [
                        {
                            position: { x: 0, y: 100 },
                            rate: { quantity: 8, delay: 0.15 },
                            particles: {
                                move: {
                                    direction: "top-right",
                                    outModes: { top: "none", default: "destroy" },
                                    speed: { min: 20, max: 50 },
                                    gravity: { enable: true }
                                }
                            }
                        },
                        {
                            position: { x: 100, y: 100 },
                            rate: { quantity: 8, delay: 0.15 },
                            particles: {
                                move: {
                                    direction: "top-left",
                                    outModes: { top: "none", default: "destroy" },
                                    speed: { min: 20, max: 50 },
                                    gravity: { enable: true }
                                }
                            }
                        },
                        {
                            position: { x: 50, y: 100 },
                            rate: { quantity: 10, delay: 0.2 },
                            particles: {
                                move: {
                                    direction: "top",
                                    outModes: { top: "none", default: "destroy" },
                                    speed: { min: 25, max: 55 },
                                    gravity: { enable: true }
                                }
                            }
                        }
                    ],
                    particles: {
                        number: { value: 0 },
                        color: {
                            value: ["#ffffff", "#FF0000", "#00FF00", "#0000FF", "#FFFF00", "#FF00FF"]
                        },
                        shape: { type: ["circle", "square", "triangle", "polygon"] },
                        opacity: { value: 1 },
                        size: {
                            value: { min: 2, max: 5 },
                            animation: { enable: true, speed: 16, sync: false }
                        },
                        move: {
                            decay: 0.05,
                            enable: true,
                            gravity: { enable: true },
                            outModes: { top: "none", default: "destroy" },
                            speed: { min: 10, max: 50 }
                        },
                        rotate: {
                            value: { min: 0, max: 360 },
                            direction: "random",
                            animation: { enable: true, speed: 30 }
                        },
                        tilt: {
                            direction: "random",
                            enable: true,
                            value: { min: 0, max: 360 },
                            animation: { enable: true, speed: 30 }
                        },
                        roll: {
                            darken: { enable: true, value: 25 },
                            enable: true,
                            speed: { min: 5, max: 15 }
                        },
                        wobble: {
                            distance: 30,
                            enable: true,
                            speed: { min: -7, max: 7 }
                        }
                    }
                });
            } else {
                console.error("tsParticles chưa load từ CDN!");
            }
        });
    }
};
</script>

<style>
#tsparticles {
    position: fixed !important;
    inset: 0 !important;
    z-index: 1 !important;
    pointer-events: none !important;
}
#tsparticles canvas {
    pointer-events: none !important;
}

</style>
